export default {
  systems: [],
  sites: [],
  waterReadings: [],
  wasteReadings: [],
  dailyLogs: [],
  dailyLogEntries: [],
  repairLogs: [],
  repairLogEntries: [],
  images: [],
  billingItems: [],
  timeCards: [],
  timeCardEntries: [],
  payPeriods: [],
  payPeriodWeeks: [],
  currentUser: {},
  users: [],
  userRoles: [],
  userInitials: [],
  ajaxCallsInProgress: 0,
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js